import styled from 'styled-components';
import Button from 'shared/ui/Button';
import BaseCancelButton from 'shared/ui/CancelButton';
import { FORM_ACTION_MIN_WIDTH } from 'shared/ui/Button/Button.constants';

export const Wrapper = styled.div`
display:flex;
padding: 34px 0;
margin-right: 34px;
`;

export const SecondContainer = styled.div`
  margin-left: auto;
`;

export const CancelButton = styled(BaseCancelButton)`
  min-width: ${FORM_ACTION_MIN_WIDTH};
`;
CancelButton.displayName = 'CancelButton';

export const Next = styled(Button)`
  min-width: ${FORM_ACTION_MIN_WIDTH};
  margin-left: 10px;
`;
